import { bindable } from 'aurelia-framework';
import './items-list.less';


export class ItemsList {
    @bindable columns;
    @bindable cart;
    @bindable isStockOrder=false;
}
